import { render, staticRenderFns } from "./addBorder.vue?vue&type=template&id=72b20eca&scoped=true&"
import script from "./addBorder.vue?vue&type=script&lang=js&"
export * from "./addBorder.vue?vue&type=script&lang=js&"
import style0 from "./addBorder.vue?vue&type=style&index=0&id=72b20eca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b20eca",
  null
  
)

export default component.exports